export default function NotFoundPage() {
  return <div className="mt-10 text-center">Page Not Found!</div>;
}
